import React, { useState } from 'react';

import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import ViewButton from '../../elements/ViewButton';
import { ROLES } from '../../services/AdminPolicyService';

import MasterAffiliateAgentsList from './MasterAffiliateAgentsList';

function MasterAffiliateAgentPage() {
    const url = '/crea/api/master_affiliate_agent';
    const [loading, setLoading] = useState(true);

    const getLinks = (id: number) => (
        <>
            <ViewButton url={`/master_affiliate_agents/${id}`} roles={ROLES.MAIN_ADMINS} />
            <EditButton url={`/master_affiliate_agents/${id}/edit`} roles={ROLES.MAIN_ADMINS} />
            <DeleteButton url={`${url}/${id}`} action={() => setLoading(true)} roles={ROLES.MAIN_ADMINS} />
        </>
    );

    return (
        <div>
            <ActionButton
                title="Create new Master Affiliate Agent"
                url="/master_affiliate_agents/create"
                roles={ROLES.MAIN_ADMINS}
            />
            <MasterAffiliateAgentsList
                url={url}
                cardTitle="All Master Affiliate Agents"
                getLinks={getLinks}
                loading={loading}
                setLoading={setLoading}
            />
        </div>
    );
}

export default MasterAffiliateAgentPage;
